// extracted by mini-css-extract-plugin
export default {"gridContainer":"clientPropertyView_gridContainer__-Ub3E"};